import configurationReducer from '../configuration/reducer';
import controllingReducer from '../controlling/reducer';
import defaultReducer from '../default/reducer';
import detailsReducer from '../details/reducer';
import devToolsReducer from '../devTools/reducer';
import errorReducer from '../error/reducer';
import loadingReducer from '../loading/reducer';
import measuresReducer from '../measures/reducer';
import paintingReducer from '../painting/reducer';
import presetsReducer from '../presets/reducer';
import propertiesReducer from '../properties/reducer';
import testingReducer from '../testing/reducer';
import { combineReducers } from 'redux';

const rootReducer = combineReducers({
  controlling: controllingReducer,
  details: detailsReducer,
  error: errorReducer,
  loading: loadingReducer,
  measures: measuresReducer,
  painting: paintingReducer,
  presets: presetsReducer,
  properties: propertiesReducer,
  testing: testingReducer,
  devTools: devToolsReducer,
  configuration: configurationReducer,
  default: defaultReducer,
});

export default rootReducer;
